import type { ReactNode } from "react";
import { Icon, type IconType } from "../Icon";
import { SlideTransition } from "../SlideTransition";

export type AccordionItemId = string | number;

export type AccordionItemType = {
  id: AccordionItemId;
  title: string;
  children: ReactNode;
  isOpen: boolean;
  onToggle: (id: AccordionItemId) => void;
  closedIcon?: IconType;
};

export const AccordionItem = ({
  id,
  title,
  children,
  isOpen,
  onToggle,
  closedIcon = "PLUS",
}: AccordionItemType) => {
  return (
    <div>
      <button
        type="button"
        aria-expanded={isOpen}
        aria-controls={`accordion-panel-${id}`}
        onClick={() => onToggle(id)}
        className="flex w-full cursor-pointer items-center justify-between border-b border-zinc-300 py-4 text-left"
      >
        <span className="text-lg font-semibold">{title}</span>
        <span className="flex items-center">
          <Icon icon={isOpen ? "CHEVRON_UP" : closedIcon} />
        </span>
      </button>

      <SlideTransition show={isOpen}>
        <div className="flex flex-col gap-8 py-8">{children}</div>
      </SlideTransition>
    </div>
  );
};
